import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { ValidatorFn, Validators } from "@angular/forms";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { GeneralLedger, GroupLedger } from "projects/sepidz-web-framework/src/lib/models";
import { MisSetupService } from "projects/sepidz-web-framework/src/lib/services/missetup.service";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "generalledger-form",
  templateUrl: "generalledger-form.component.html",
  styleUrls: ["generalledger-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GeneralLedgerFormComponent extends BaseFormComponent<GeneralLedger> {
  private selectedgeneralLedgerCodeLen: number;
  private selectedGroupLedgerCodeLen: number;

  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef, private missetup: MisSetupService) {
    super(selectorService, cd);
    this.missetup.getall();
  }
  async ngOnInit() {
    this.apiName = "GeneralLedger";
    this.label = this.translate("ClientApp.BackOffice.ACC.GeneralLedger.GeneralLedger");
    super.ngOnInit();
    this.setlen();
  }
  setlen() {
    this.selectedgeneralLedgerCodeLen = this.missetup.getnumber("ACC", "GLLEN");
    this.selectedGroupLedgerCodeLen = this.missetup.getnumber("ACC", "PLLEN");
    if (this.selectedgeneralLedgerCodeLen === 0 && this.selectedGroupLedgerCodeLen === 0)
      this.sts.showDialog(
        this.translate("ClientApp.BackOffice.ACC.GeneralLedger.SettingNotComplete"),
        this.translate("ClientApp.BackOffice.ACC.GeneralLedger.ErrorSetting")
      );

    if (this.columns && this.columns.length > 0) {
      var item = this.columns.filter((item) => item.name === "Code")[0];

      if (item) {
        item.maxLength = this.selectedgeneralLedgerCodeLen + this.selectedGroupLedgerCodeLen;
        item.minLength = this.selectedGroupLedgerCodeLen + 1;
      }
    }
  }

  onChange($event: GroupLedger) {
    if ($event && $event.GroupLedgerKindId && this.isNewRow) {
      this.model.GroupLedgerId = $event.Id;
      this.model.GroupLedgerCode = $event.Code;
      this.setMaxCode();
    }
  }
  setMaxCode() {
    if (!this.selectedgeneralLedgerCodeLen || this.selectedgeneralLedgerCodeLen === 0) this.setlen();

    this.httpCommonService
      .getMaxCodeWithParameter(this.apiName, this.model.GroupLedgerId, this.model.GroupLedgerCode, this.selectedgeneralLedgerCodeLen)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data) => {
        if (data) {
          this.model["Code"] = data as number;
          this.setdefault();
          if (this.formGroup && this.formGroup.controls["Code"]) {
            this.formGroup.controls["Code"].setValue(data as number);
            this.setColumnAttribute();
          }
        }
      });
  }
  isValid() {
    if (!this.selectedgeneralLedgerCodeLen || this.selectedgeneralLedgerCodeLen <= 0) this.setlen();
    let result =
      this.model.Code &&
      this.model.Code.toString().length > this.selectedGroupLedgerCodeLen &&
      this.model.Code.toString().length <= this.selectedgeneralLedgerCodeLen + this.selectedGroupLedgerCodeLen &&
      this.model.Code.toString().substring(0, this.selectedGroupLedgerCodeLen) === this.model.GroupLedgerCode.toString();
    if (!result)
      this.formGroup.controls["Code"].setErrors({ customerror: `${this.translate("ClientApp.BackOffice.ACC.GeneralLedger.GeneralLedgerWrong")}` });
    return result;
  }

  setColumnAttribute() {
    let minfprmat = [10, 100, 1000, 10000, 100000, 1000000];
    let maxfprmat = [9, 99, 999, 9999, 99999, 999999];
    this.columns.forEach((x) => {
      if (x.name === "GroupLedgerId") x.disabled = !this.isNewRow;
      if (x.name === "Code" && this.model.GroupLedgerCode) {
        x.min = this.model.GroupLedgerCode * minfprmat[this.selectedGroupLedgerCodeLen - 1];
        x.max = Number(this.model.GroupLedgerCode.toString() + maxfprmat[this.selectedgeneralLedgerCodeLen - 1].toString());
        if (this.formGroup.get("Code")) {
          let validator: ValidatorFn[] = [];
          if (x.required && !x.disabled) validator.push(Validators.required);
          if (x.max && x.max > 0) validator.push(Validators.max(x.max));
          if (x.min && x.min > 0) validator.push(Validators.min(x.min));
          this.formGroup.get("Code").setValidators(validator);
        }
      }
    });
  }
}
